// The Main Site Object
window.Site = {

    menuItems    : document.querySelectorAll('.header-menu-item'),
    activeMenu   : null,
    menuSections : document.querySelectorAll('.main-menu'),

    mobileMenuButton    : document.querySelector('.header-menu-button'),
    mobileMenuContainer : document.querySelector('.mobile-menu'),

    // Init Function
    liftoff : () => {
        Site.showNavsOnClick()
        Site.showMobileNavOnClick()
        Site.hideNavOnMouseLeave()
    },

    showNavsOnClick : () => {
    
        Site.menuItems.forEach(menuItem => {
            menuItem.addEventListener('click' , () => {

                let targetMenu = document.getElementById(menuItem.value);
                
                if (Site.activeMenu && Site.activeMenu != targetMenu) {
                    Site.activeMenu.classList.remove('main-menu-active')
                }

                targetMenu.classList.toggle('main-menu-active');
                Site.activeMenu = targetMenu
            })
        })

    },

    hideNavOnMouseLeave : () => {

        Site.menuSections.forEach(menuSection => {
            console.log('YOLO')
            menuSection.addEventListener('mouseleave' , () => {
                menuSection.classList.remove('main-menu-active');
            })
        })

    },

    showMobileNavOnClick : () => {
        Site.mobileMenuButton.addEventListener('click' , () => {

            Site.mobileMenuButton.firstElementChild.classList.toggle('visible')
            Site.mobileMenuButton.lastElementChild.classList.toggle('visible')
            Site.mobileMenuContainer.classList.toggle('mobile-menu-active')

        })
    }

}

// Launch The Script
Site.liftoff()